<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box" style="">
            <h2 class="history_box-head">{{ $t('AccountSecurity.Setupmysecurityquestions') }}</h2>

            <div style="display: flex">
              <button class="btn_blue flex_center change_btn_gray" v-if="Edit" @click="Edit = !Edit">
                {{ $t('ContactInfo.Edit') }}
              </button>
              <div v-else style="display: flex">
                <button class="btn_blue flex_center change_btn_mr10" @click="changesave()">
                 {{ $t('MyAccount.Save') }}
                </button>
                <button class="btn_blue flex_center change_btn_gray"
                  @click="Edit = !Edit, CategoryVal = '', CategoryVal2 = '', CategoryVal3 = '',getUserSimpleInfo()">
                 {{ $t('MyAccount.Cancel') }}
                </button>
              </div>
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select style="width: 100%" v-model="IndicatorsValType" :placeholder="$t('AccountSecurity.Pleasechooseaquestion')">
                  <el-option v-for="(item, index) in type" :key="index" :label="item.type == '1'
                    ? 'Online data'
                    : item.type == '2'
                      ? 'Offline data'
                      : item.type
                    " :value="item.type"></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" clearable v-model="CategoryVal"
                  :placeholder="$t('AccountSecurity.Pleaseentertheanswertothequestion')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select style="width: 100%" v-model="IndicatorsValType" :placeholder="$t('AccountSecurity.Pleasechooseaquestion')">
                  <el-option v-for="(item, index) in type" :key="index" :label="item.type == '1'
                    ? 'Online data'
                    : item.type == '2'
                      ? 'Offline data'
                      : item.type
                    " :value="item.type"></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" clearable v-model="CategoryVal"
                  :placeholder="$t('AccountSecurity.Pleaseentertheanswertothequestion')"></el-input>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-select style="width: 100%" v-model="IndicatorsValType" :placeholder="$t('AccountSecurity.Pleasechooseaquestion')">
                  <el-option v-for="(item, index) in type" :key="index" :label="item.type == '1'
                    ? 'Online data'
                    : item.type == '2'
                      ? 'Offline data'
                      : item.type
                    " :value="item.type"></el-option>
                </el-select>
              </div>
            </div>
            <div class="information-content">
              <div class="sel_box computer_right_cont_box">
                <el-input class="inline-input" clearable v-model="CategoryVal"
                  :placeholder="$t('AccountSecurity.Pleaseentertheanswertothequestion')"></el-input>
              </div>
            </div>
          </div>
          <div class="flex_center_between_box" style="margin-top: 40px; margin-bottom: 20px">
            <h2 class="history_box-head">{{ $t('AccountSecurity.SessionTimeoutAutomaticLogoutSettings') }}
</h2>
          </div>
          <div class="his_sel_box">
            <div class="information-content">
              <div class="sel_box sel_boxnum computer_right_cont_box">
                    <el-select style="width: 100%" v-model="timeValue" :disabled="Edit" placeholder="">
                  <el-option v-for="(item, index) in timeValueOption" :key="index"  @input="validateInput" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </div>

            <span class="tixing">{{ $t('AccountSecurity.Thesystemwillautomatically') }}</span>

          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { setLoginRetentionTime } from "@/api/api.js";
import { getUserSimpleInfo } from "@/api/companyApi.js";
import ReLogin from "../../../components/ReLogin.vue";
export default {
  mixins: [mixins1],
  components: {
    ReLogin
  },
  data() {
    return {
      reLoginVis: false,
      value1: "",
      CategoryVal: "",
      timeValueOption:[8,12,24],
      CategoryVal2: "",
      CategoryVal3: "",
      type: [],
      window: window,
      IndicatorsValType: "",
      timeValue: 8,
      Edit: true,
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getUserSimpleInfo()
  },

  methods: {
    getUserSimpleInfo() {
      getUserSimpleInfo().then(res => {
        this.timeValue = res.data.retentionHours

      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      })
    },
    validateInput() {
      // 获取输入的值
      const value = this.timeValue;

      // 使用正则表达式检查是否为整数
      if (!/^\d*$/.test(value)) {
        // 如果不是整数，清空输入框
        this.timeValue = '';
      }
    },
    changesave() {
      setLoginRetentionTime({
        hours: this.timeValue
      }).then(res => {



        if (res.code == 200) {
          this.getUserSimpleInfo()
          this.$message({
            message: res.msg,
            center: true,
            type: 'success',
          });
          this.Edit = !this.Edit

        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: 'error',
          });
        }
      })
    },

  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  border-radius: 0.5714285714285714rem;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box {
  margin-right: 1.7857142857142858rem;
  width: 35%;
  height: 2.857142857142857rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc !important;
  border-radius: 0.5714285714285714rem;
  color: #A2A9B0;
  font-size: 1.285714285714286rem !important;
  height: 3.5714285714285716rem;
}

.sel_boxnum /deep/ .el-input__inner {
  color: #1A2332 !important;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table {
  margin-top: 2.142857142857143rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}


/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

@media screen and (max-width: px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

.information-content {
  display: flex;
  margin-bottom: 1.1428571428571428rem;
}

.btn_eee {
  background: #eee;
  color: #1a2332;
}

.tixing {
  margin-top: -0.42857142857142855rem;
  font-size: 1rem;
  color: #F56B6B;
  line-height: 1.2857142857142858rem;
  width: 37.857142857142854rem;
  display: block;
}
</style>